var React = require('react');

function AttachLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M35.786 4.325a10.213 10.213 0 00-7.221 2.992L4.097 31.781a7.157 7.157 0 0010.12 10.122l23.41-23.485.016-.015a3.076 3.076 0 00-.969-5.07 3.078 3.078 0 00-3.383.718l-.014.014-17.332 17.332a1 1 0 01-1.415-1.414l17.326-17.326a5.077 5.077 0 117.18 7.18L15.63 43.317a9.156 9.156 0 11-12.948-12.95L27.15 5.903a12.213 12.213 0 0117.273 17.27l-17.33 17.334a1 1 0 01-1.415-1.414l17.33-17.334a10.213 10.213 0 00-7.222-17.434z"}));
}

AttachLight.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = AttachLight;

AttachLight.default = AttachLight;
